import Vue from 'vue'
import Router from 'vue-router'
import firebase from "firebase"

import MiddlewareGame from './views/middleware/MiddlewareGame'

import AccessOptions from './views/login/AccessOptions.vue'
import Login from './views/login/Login'
import Logout from './views/login/Logout'

import ForgotPass from './views/login/ForgotPass.vue'
import ForgotPassEmail from './views/login/ForgotPassEmail.vue'
import SendForgotSuccess from './views/login/SendForgotSuccess.vue'
import ForgotPassSuccess from './views/login/ForgotPassSuccess.vue'

import RegisterByEmail from './views/login/RegisterByEmail.vue'
import RegisterSuccess from './views/login/RegisterSuccess.vue'
import InfosRegister from './views/login/InfosRegister.vue'

Vue.use(Router);

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'home',
      component: AccessOptions,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/forgot-pass',
      name: 'forgot-pass',
      component: ForgotPass,
    },
    {
      path: '/forgot-pass-email',
      name: 'forgot-pass-email',
      component: ForgotPassEmail,
    },
    {
      path: '/send-forgot-success',
      name: 'send-forgot-success',
      component: SendForgotSuccess,
    },
    {
      path: '/forgot-pass-success',
      name: 'forgot-pass-success',
      component: ForgotPassSuccess,
    },
    {
      path: '/register-email',
      name: 'register-email',
      component: RegisterByEmail,
    },
    {
      path: '/infos-register',
      name: 'infos-register',
      component: InfosRegister
    },
    {
      path: '/register-success',
      name: 'register-success',
      component: RegisterSuccess,
    },
    {
      path: '/middleware-game',
      name: 'middleware-game',
      component: MiddlewareGame,
      meta: {
        requiresAuth: true,
      }
    }
  ],
});

// router.beforeEach((to, from, next) => {
// 	const currentUser = firebase.auth().currentUser;
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   let game = ''
//   if(to.query.game){
//     game = to.query.game
//     localStorage.setItem('game-redirect', game)
//   }
//   if(requiresAuth && !currentUser){
//     next('home')
//   } else if (!requiresAuth && currentUser) {
//     if(to.name == 'logout'){
//       const workspaceId = to.query.workspaceId 
//       firebase.auth().signOut().then(response => {
//         next(`/?workspaceId=${workspaceId}`)
//       })
//       return 
//     }
//     next('middleware-game')
//   }else {
//     next()
//   }
// });

export default router;
